import { Paper, Stack } from "@mantine/core";
import CustomTextInput from "./CustomTextInput/CustomTextInput";
import CustomBadge from "./CustomBadge/CustomBadge";

const AccountCard = ({
  data,
  fields,
  badges = [],
  className = "",
  onClick,
  ...props
}) => {
  return (
    <Paper
      withBorder
      p="lg"
      radius="md"
      className={`bg-gray-50 hover:bg-gray-100 transition-all duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer ${className}`}
      onClick={onClick}
      {...props}
    >
      <Stack gap="sm">
        {fields.map((field) => (
          <CustomTextInput
            key={field.key}
            label={field.label}
            value={data[field.key] || field.defaultValue || "-"}
            readOnly
            radius="xl"
            variant="filled"
            leftSection={field.icon}
          />
        ))}

        {badges.length > 0 && (
          <div className="flex gap-2 mt-2">
            {badges.map((badge, idx) => (
              <CustomBadge
                key={idx}
                color={badge.color}
                variant={badge.variant || "light"}
                size={badge.size || "sm"}
              >
                {badge.text}
              </CustomBadge>
            ))}
          </div>
        )}
      </Stack>
    </Paper>
  );
};

export default AccountCard;
